/**
 * Filters array by key & term, returns filtered array
 */
export default function filterArrayByKey<T>(array: T[], key: string | number, term: string): T[] {
    return array.filter((item) => item[key].toLowerCase()
        .includes(term.toLowerCase())) ?? []
}